export default "__VITE_ASSET__BbhIJ5Vu__"